const [{ ShadowElement }, cart, connectSignalMixin] = await Promise.all([
	importMod("shadow-mixin"),
	importDefault("cart"),
	importDefault("connect-signal-mixin"),
]);

export default class ProductVariantCard extends connectSignalMixin(
	ShadowElement
) {
	connectedCallback() {
		super.connectedCallback();
		const addToCart = this.shadow.getElementById("addToCart");
		if (!addToCart) return console.error("addToCart button not found");

		addToCart.addEventListener(
			"click",
			async () => {
				try {
					const variantId = +(addToCart.dataset.variantId ?? 0);
					if (!variantId) return;
					await cart.addItem(variantId, 1);
					this.dispatchEvent(
						new CustomEvent("product-variant-added", {
							bubbles: true,
							composed: true,
							detail: variantId,
						})
					);
				} catch (error) {
					console.error(error);
				}
			},
			{ signal: this.connectedSignal }
		);
	}
}

customElements.define("product-variant-card", ProductVariantCard);
